module.exports = __webpack_public_path__ + "img/nota-updated.c245211e.png";